<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/bruno-giacosa')">Bruno Giacosa
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/cantina-roberto-voerzio')">Cantina Roberto
                        Voerzio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/conterno-fantino')">Conterno Fantino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/g-d-vajra')">G. D. Vajra
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/gaja')">Gaja
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giacomo-conterno')">Giacomo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio')">Giuseppe
                        Mascarello e Figlio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/massolino')">Massolino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/poderi-aldo-conterno')">Poderi Aldo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/roagna')">Roagna
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/piedmont/tenuta-la-giustiniana')">Tenuta La
                        Giustiniana
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/vigne-marina-coppi')">Vigne Marina Coppi
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Tenuta La Giustiniana</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Situato in alto nell'Appennino ligure, un'ora a nord di Genova in Piemonte, si trova il vino italiano
                        Tenuta La Giustiniana. Una storia rinomata che risale a oltre 1.000 anni (si dice che
                        c'era un insediamento benedettino di produttori di vino sulla terra nel 900 dC), questo piccolo italiano
                        la cantina potrebbe essere piccola ma presto darà un grande pugno.
                    </div>

                    <div class="howto-title2">Rinnovo e riscoperta</div>
                    <div class="howto-text">
                        Fondata dalla famiglia Giustiniana nel 1625, La Giustiniana è chiaramente una delle cantine più antiche della zona di Gavi. I documenti mostrano che la tenuta funzionava come azienda vinicola già nel XV secolo, ma poca attenzione veniva prestata al suo superbo potenziale viticolo e purtroppo,
                        il prodotto ha funzionato dietro i suoi pari. Avanti veloce al 2015 quando Magda Pedrini e Stefano
                        Massone acquistò il terreno e iniziò un massiccio processo di ristrutturazione progettato per portare Tenuta La
                        Giustiniana torna sotto i riflettori. La coppia ha fatto enormi investimenti prima nel rinnovamento del
                        vigneti (Tenuta La Giustiniana vanta due Grand Cru: Montessora e Lugarara e un ulteriore
                        cuvée denominata Antiche Terre della Giustiniana) seguita dal restauro in corso della bellissima
                        Palazzo seicentesco un tempo dimora della famiglia Giustina. In parallelo ci sono anche le cantine
                        in fase di restauro: fondendo la moderna tecnologia con la tradizione Pedrinini e Massone possono essere
                        investendo una fortuna ma sembra che ne varrà la pena.
                    </div>

                    <div class="howto-title2">Un vino italiano da tenere d'occhio</div>
                    <div class="howto-text">
                        110 ettari di uva bianca 100% Cortese sono coltivati in modo sostenibile senza l'utilizzo di prodotti chimici o
                        erbicidi. Le uve sono esposte a sud ad un'altitudine compresa tra i 300 e i 500 m
                        metri e ad una latitudine di 44°41', che curiosamente sono le stesse identiche latitudini di Graves
                        in Francia. Il prodotto stesso ha ancora un po' di strada da fare prima di raggiungere il suo precedente vertigine
                        altezze nella classifica del vino italiano, ma Pedrinini e Massone stanno giocando a lungo con
                        Tenuta La Giustiniana. Premiate l'annata 2015 del Montessora e il 2016 del Lugarara
                        medaglia di bronzo dalla rivista Decanter, e punteggi che hanno raggiunto gli alti ottanta con il primo post-2015
                        vintage, quasi inaudito per viti così giovani. Molto, molto a prezzi ragionevoli, lo sospettiamo
                        entro il 2025 Tenuta La Giustiniana sarà uno dei vini italiani più chiacchierati sul mercato.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Tenuta La Giustiniana</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Hoch oben im ligurischen Apennin, eine Stunde nördlich von Genua im Piemont, liegt italienischer Wein
                        Anwesen Tenuta La Giustiniana. Eine angebliche Geschichte, die über 1.000 Jahre zurückreicht (Gerüchten zufolge).
                        Im Jahr 900 n. Chr. befand sich auf dem Land eine benediktinische Weinbausiedlung), dieser kleine Italiener
                        Das Weingut mag klein sein, aber es wird bald eine große Wirkung haben.
                    </div>

                    <div class="howto-title2">Renovierung und Wiederentdeckung</div>
                    <div class="howto-text">
                        La Giustiniana wurde 1625 von der Familie Giustiniana gegründet und ist eindeutig eines der ältesten Weingüter in der Gegend von Gavi. Aufzeichnungen zeigen, dass das Anwesen bereits im 15. Jahrhundert als Weingut fungierte, seinem hervorragenden Weinbaupotenzial jedoch wenig Aufmerksamkeit geschenkt wurde und leider
                        Das Produkt blieb hinter seinen Mitbewerbern zurück. Schneller Vorlauf ins Jahr 2015, als Magda Pedrini und Stefano
                        Massone kaufte das Land und begann mit einem umfassenden Renovierungsprozess, um Tenuta La zu erschaffen
                        Giustiniana zurück im Rampenlicht. Das Ehepaar investierte zunächst massiv in die Erneuerung des Gebäudes
                        Weinberge (Tenuta La Giustiniana verfügt über zwei Grand Crus: Montessora und Lugarara und einen weiteren
                        Cuvée namens Ancient Lands of Giustiniana), gefolgt von der fortlaufenden Restaurierung des Schönen
                        Palazzo aus dem 17. Jahrhundert, in dem einst die Familie Giustina wohnte. Parallel dazu sind auch die Keller
                        restauriert: Die Verschmelzung moderner Technologie mit der Tradition könnte Pedrinini und Massone sein
                        Ich investiere ein Vermögen, aber es sieht so aus, als würde es sich lohnen.
                    </div>

                    <div class="howto-title2">Ein italienischer Wein, den man sich ansehen sollte</div>
                    <div class="howto-text">
                        110 Hektar 100 % weiße Cortese-Trauben werden nachhaltig und ohne chemische Produkte angebaut
                        Herbizide. Die Trauben werden in einer Höhe zwischen 300 und 500 m nach Süden ausgerichtet
                        Meter und auf einem Breitengrad von 44 ° 41 ', was interessanterweise genau die gleichen Breitengrade wie Graves sind
                        in Frankreich. Das Produkt selbst hat noch einen kleinen Weg vor sich, bis es seinen vorherigen Schwindel erreicht
                        Spitzenreiter in der italienischen Wein-Rangliste, aber Pedrinini und Massone haben lange Zeit damit zu kämpfen
                        Tenuta La Giustiniana. Sowohl der Jahrgang 2015 von Montessora als auch der Jahrgang 2016 von Lugarara wurden ausgezeichnet
                        Bronzemedaille vom Decanter-Magazin, und die Punktzahlen erreichten mit dem ersten Post-2015 die hohen 80er-Jahre
                        Jahrgang, fast unbekannt für solch junge Reben. Sehr, sehr günstig, das vermuten wir
                        Bis 2025 wird Tenuta La Giustiniana einer der meistdiskutierten italienischen Weine auf dem Markt sein.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Tenuta La Giustiniana</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Situé haut dans les Apennins Liguariens, à une heure au nord de Gênes dans le Piémont, se trouve le vin italien
                        domaine Tenuta La Giustiniana. Une histoire réputée remontant à plus de 1 000 ans (la rumeur veut que
                        il y avait une colonie viticole bénédictine sur la terre en 900 après JC), ce petit italien
                        La cave est peut-être petite, mais elle va bientôt faire un gros coup de poing.
                    </div>

                    <div class="howto-title2">Rénovation et redécouverte</div>
                    <div class="howto-text">
                        Fondée par la famille Giustiniana en 1625, La Giustiniana est clairement l'une des plus anciennes caves de la région de Gavi. Les archives montrent que le domaine fonctionnait comme une cave dès le 15ème siècle, mais peu d'attention a été accordée à son superbe potentiel viticole et malheureusement,
                        le produit a travaillé derrière ses pairs. Avance rapide jusqu'en 2015 lorsque Magda Pedrini et Stefano
                        Massone a acheté le terrain et a commencé un processus de rénovation massif prévu pour amener Tenuta La
                        Giustiniana revient sur le devant de la scène. Le couple a fait d'énormes investissements d'abord dans le renouvellement de la
                        vignobles (Tenuta La Giustiniana compte deux Grands Crus : Montessora et Lugarara et un autre
                        cuvée appelée Ancient Lands of Giustiniana) suivi de la restauration en cours de la belle
                        Palais du XVIIe siècle qui abritait autrefois la famille Giustina. En parallèle les caves sont également
                        en cours de restauration : fusion de la technologie moderne avec la tradition Pedrinini et Massone peuvent être
                        investir une fortune, mais il semble que cela en vaudra la peine.
                    </div>

                    <div class="howto-title2">Un vin italien à surveiller</div>
                    <div class="howto-text">
                        110 hectares de raisins blancs 100% Cortese sont cultivés de manière durable sans produits chimiques ni
                        herbicides. Les raisins sont exposés au sud à une altitude comprise entre 300 et 500
                        mètres et à une latitude de 44 ° 41 ', qui sont curieusement exactement les mêmes latitudes Graves
                        en France. Le produit lui-même a encore un peu de chemin à parcourir avant d'atteindre son vertige précédent
                        des sommets au classement des vins italiens, mais Pedrinini et Massone jouent un long jeu avec
                        Tenuta La Giustiniana. Le millésime 2015 de Montessora et le Lugarara 2016 ont tous deux été primés
                        médaille de bronze par le magazine Decanter, et les scores ont atteint les années quatre-vingt avec le premier post-2015
                        millésime presque inédit pour de si jeunes vignes. Prix très, très raisonnable, nous soupçonnons que
                        d'ici 2025 Tenuta La Giustiniana sera l'un des vins italiens dont on parle le plus sur le marché.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Tenuta La Giustiniana</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Set high in the Liguarian Appennines, an hour north of Genova in Piedmont, lies Italian wine
                        estate Tenuta La Giustiniana. A reputed history dating back over 1,000 years (rumour has it that
                        there was a Benedictine wine-producing settlement on the land in 900 AD), this little Italian
                        winery might be small but it will soon be packing a big punch.
                    </div>

                    <div class="howto-title2">Renovation and rediscovery</div>
                    <div class="howto-text">
                        Founded by the Giustiniana family in 1625, La Giustiniana is clearly one of the oldest wineries in the area of Gavi. Records show that as the estate was functioning as a winery as far back as the 15th century, but little attention was paid to its superb viticultural potential and sadly,
                        the product laboured behind its peers. Fast forward to 2015 when Magda Pedrini and Stefano
                        Massone bought the land and began a massive renovation process planned to bring Tenuta La
                        Giustiniana back to the spotlight. The couple made huge investments first in the renewal of the
                        vineyards (Tenuta La Giustiniana boasts two Grand Crus: Montessora and Lugarara and a further
                        cuvée called Ancient Lands of Giustiniana) followed by the ongoing restoration of the beautiful
                        17th-century palazzo that was once home to the Giustina family. In parallel the cellars are also
                        being restored: fusing modern technology with traditionality Pedrinini and Massone may be
                        investing a fortune but it looks like it will be worth it.
                    </div>

                    <div class="howto-title2">An Italian wine to watch</div>
                    <div class="howto-text">
                        110-hectares of 100% Cortese white grapes are sustainably farmed using no chemical products or
                        herbicides. The grapes are given southern exposure at an altitude ranging between 300 and 500
                        meters and at a latitude of 44 ° 41 ', which interestingly are the exact same latitudes Graves
                        in France. The product itself still has a little way to go before it reaches its previous giddy
                        heights on the Italian wine leader board, but Pedrinini and Massone are playing a long game with
                        Tenuta La Giustiniana. The 2015 vintage of Montessora and the 2016 Lugarara were both awarded
                        bronze medal by Decanter magazine, and scores reached the high eighties with the first post-2015
                        vintage, almost unheard of for such young vines. Very, very reasonably priced, we suspect that
                        by 2025 Tenuta La Giustiniana will be one of the most talked about Italian wines on the market.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TenutaLaGiustiniana",
    head: {
        title: 'Tenuta La Giustiniana | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional wine-making of Tenuta La Giustiniana, a renowned Piedmont wine producer known for its high-quality, hand-crafted wines. Savor the unique flavors and aromas of the region with every sip of a bottle from Tenuta La Giustiniana.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Tenuta La Giustiniana', src: '/wine-guide/italy/piedmont/tenuta-la-giustiniana'},
            items: [
                {report: 'Bruno Giacosa', src: '/wine-guide/italy/piedmont/bruno-giacosa'},
                {report: 'Cantina Roberto Voerzio', src: '/wine-guide/italy/piedmont/cantina-roberto-voerzio'},
                {report: 'Conterno Fantino', src: '/wine-guide/italy/piedmont/conterno-fantino'},
                {report: 'G. D. Vajra', src: '/wine-guide/italy/piedmont/g-d-vajra'},
                {report: 'Gaja', src: '/wine-guide/italy/piedmont/gaja'},
                {report: 'Giacomo Conterno', src: '/wine-guide/italy/piedmont/giacomo-conterno'},
                {
                    report: 'Giuseppe Mascarello e Figlio',
                    src: '/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio'
                },
                {report: 'Massolino', src: '/wine-guide/italy/piedmont/massolino'},
                {report: 'Poderi Aldo Conterno', src: '/wine-guide/italy/piedmont/poderi-aldo-conterno'},
                {report: 'Roagna', src: '/wine-guide/italy/piedmont/roagna'},
                {report: 'Tenuta La Giustiniana', src: '/wine-guide/italy/piedmont/tenuta-la-giustiniana'},
                {report: 'Vigne Marina Coppi', src: '/wine-guide/italy/piedmont/vigne-marina-coppi'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
